import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import VueLazyload from 'vue-lazyload'
import PortalVue from 'portal-vue'

import './router/routerStack'
import '@/assets/style/index.scss'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: './static/images/bg_default.png',
  loading: './static/images/bg_default.png',
  attempt: 1
})

Vue.use(PortalVue)

if (process.env.NODE_ENV === 'development') {
  require('./jsBridgeSimulate')
}

Vue.config.ignoredElements = ['wx-open-launch-weapp']

// 往你的cookie里面加一个"originDevelopeMode"，就可以去掉eruda，我本地是非常不喜欢这个工具的
/** 因ios低版本手机不兼容eruda的引入 故使用时再解开注释调试 */
if (process.env.VUE_APP_RUN_ENV !== 'pro' && document.cookie.indexOf('originDevelopeMode') === -1) {
  const eruda = require('eruda')
  eruda.init()
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
